import Swal from 'sweetalert2';

export const sweetAlert = async (message) => {
  try {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
      customClass:{
        confirmButton:"btn-confirm"
      }
    });
    return result;
  } catch (error) {
    console.error("SweetAlert error:", error);
    return { isConfirmed: false };
  }
};
